export default __webpack_public_path__ + "static/media/gal-4.be4c30ec.jpeg";